module.exports = __webpack_public_path__ + "img/eg-14-01.bbd1e1ef.jpg";